import { call, select, put } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { setIntegrations } from '../../../effects/organization';

export default function* getIntegrations() {
  const { AUTH_SERVER_URL } = yield select((state) => state.application.env);
  const { uuid } = yield select((state) => state.organization);
  const url = `${AUTH_SERVER_URL}/integrations?organizationUuid=${uuid}`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(setIntegrations({ ...result }));
  } else {
    console.error(error);
  }
}
